import React from "react";
import PropTypes from "prop-types";
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from "@mui/material";

const MySelect = ({
  label,
  options,
  value,
  onChange,
  multiple = false,
  fullWidth = true,
  getOptionValue,
  getOptionLabel,
}) => {
  const isSelected = (option) =>
    multiple ? value.includes(getOptionValue(option)) : value === getOptionValue(option);

  return (
    <FormControl fullWidth={fullWidth} variant="outlined">
      <InputLabel>{label}</InputLabel>
      <Select
        multiple={multiple}
        value={value}
        onChange={onChange}
        renderValue={(selected) =>
          multiple
            ? options
                .filter((option) => selected.includes(getOptionValue(option)))
                .map((option) => getOptionLabel(option))
                .join(", ")
            : options.find((option) => getOptionValue(option) === selected)
                ? getOptionLabel(options.find((option) => getOptionValue(option) === selected))
                : ""
        }
        label={label}
      >
        {options.map((option) => (
          <MenuItem key={getOptionValue(option)} value={getOptionValue(option)}>
            {multiple && <Checkbox checked={isSelected(option)} />}
            <ListItemText primary={getOptionLabel(option)} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

MySelect.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  onChange: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  fullWidth: PropTypes.bool,
  getOptionValue: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
};

export default MySelect;
